import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  console.log("result = ", result);

  // If access token has expired
  if (result?.error?.status === 401) {
    const state = api.getState();
    const refreshToken = state.auth.refreshToken;

    if (!refreshToken) {
      api.dispatch({ type: "LOGOUT" });
      return result;
    }

    // Try refreshing the token
    const refreshResult = await baseQuery(
      {
        url: "/WebAuth/RefreshToken",
        method: "POST",
        params: { token: refreshToken },
      },
      api,
      extraOptions
    );

    if (refreshResult?.data?.data?.token) {
      // Update the auth state
      api.dispatch({
        type: "SIGN_IN",
        payload: {
          token: refreshResult.data.data.token,
          refreshToken: refreshResult.data.data.refreshToken,
          currentUser: state.auth.currentUser,
          role: state.auth.role,
        },
      });

      // Retry the original request with new token
      result = await baseQuery(args, api, extraOptions);
    } else {
      // Refresh failed – force logout
      api.dispatch({ type: "LOGOUT" });
    }
  }

  return result;
};

export default baseQueryWithReauth;